/*
 * @Author: 刘小博
 * @Date: 2022-11-11 17:18:46
 * @LastEditTime: 2023-03-22 11:17:03
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\store\modules\data.js
 * 文件备注
 */
import { getGoodsList, getWebCategoriesList } from '@/api/goods'
import { getAllDpByAccountId } from '@/api/department'
import { regionList } from '@/api/common'
import { regionForScreening, replaceProductTreeCategories } from '@/utils/util'
export default {
  namespaced: true, //命名空间
  state: {
    innerHeight: 0,
    regionList: [], //地区列表
    productList: [], //产品列表
    productTreeCategoriesList: [], //产品分类树形列表
    deptmentByAccountIdList: [] //当前登录人的部门列表
  },
  mutations: {
    //存入浏览器当前高度
    setInnerHeight(state, innerHeight) {
      state.innerHeight = innerHeight
      console.log(innerHeight, 'innerHeight')
    },
    //存入地区列表
    setRegionList(state, regionList) {
      state.regionList = regionList
    },
    //存入产品列表
    setProductList(state, productList) {
      state.productList = productList
    },
    //存入产品树形分类列表
    setProductTreeCategoriesList(state, productTreeCategoriesList) {
      state.productTreeCategoriesList = productTreeCategoriesList
    },
    //存入部门列表
    setDeptmentList(state, deptmentByAccountIdList) {
      state.deptmentByAccountIdList = deptmentByAccountIdList
    }
  },
  actions: {
    //获取地区列表
    async getRegionList(context) {
      let res = await regionList()
      if (0 === res.status) {
        console.log('获取地区列表')
        let regionList = res.data.regionList
        regionForScreening(regionList)
        regionList.unshift({
          region_id: '',
          region_name: '全国',
          tel_code: '',
          parent_id: ''
        })
        context.commit('setRegionList', regionList)
      }
    },
    //获取产品列表
    async getProductList({ commit }) {
      let res = await getGoodsList()
      if (0 === res.status) {
        console.log('获取产品列表')
        let productList = res.data
        const _item = {
          name: '全部',
          goods_id: '',
          spec: ''
        }
        productList.unshift(_item)
        commit('setProductList', productList)
      }
    },
    //获取产品树形分类列表
    async getProductTreeCategoriesList({ commit }) {
      let res = await getWebCategoriesList()
      if (0 === res.status) {
        console.log('获取产品列表')
        let productTreeCategoriesList = res.data.child
        replaceProductTreeCategories(productTreeCategoriesList)

        console.log(productTreeCategoriesList, 'productTreeCategoriesList')
        commit('setProductTreeCategoriesList', productTreeCategoriesList)
      }
    },
    //获取产品树形分类列表
    async getDeptmentList({ commit }) {
      let res = await getAllDpByAccountId()
      if (0 === res.status) {
        let deptmentByAccountIdList = res.data
        commit('setDeptmentList', deptmentByAccountIdList)
      }
    }
  }
}
